export default __webpack_public_path__ + "static/media/flag.31632c3f.png";